"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var InteractiveDom_1 = require("../../utils/InteractiveDom");
var DynamicThemeComponent_1 = require("../DynamicThemeComponent");
var ButtonBase = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonBase, _super);
    function ButtonBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isKeyboardPressed = false;
        _this.handleActive = function (active) {
            if (_this.props.onActive) {
                _this.props.onActive(active);
            }
        };
        _this.handleFocus = function (focus) {
            if (_this.props.onFocus) {
                _this.props.onFocus(focus);
            }
        };
        _this.handleHover = function (hover) {
            if (_this.props.onHover) {
                _this.props.onHover(hover);
            }
        };
        _this.handleClick = function (e) {
            if (_this.props.disabled || !_this.props.handleClick) {
                return;
            }
            _this.props.handleClick(e);
        };
        _this.handleKeyUp = function (e) {
            if (_this.props.disabled || _this.props.disableTabAccessibility) {
                return;
            }
            if (_this.isKeyboardPressed && (e.key === ' ' || e.key === 'Enter')) {
                if (_this.props.handleClick) {
                    _this.props.handleClick(e);
                }
                _this.isKeyboardPressed = false;
            }
            else if (_this.props.onKeyUp) {
                _this.props.onKeyUp(e);
            }
        };
        _this.handleKeyDown = function (e) {
            if (_this.props.disabled || _this.props.disableTabAccessibility) {
                return;
            }
            if (e.key === ' ' || e.key === 'Enter') {
                _this.isKeyboardPressed = true;
                e.preventDefault(); // Prevent default page-scrolling behavior
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };
        _this.handleBlur = function () {
            _this.isKeyboardPressed = false;
            if (_this.props.onBlur) {
                _this.props.onBlur();
            }
        };
        return _this;
    }
    ButtonBase.prototype.render = function () {
        var _a;
        var interactiveDomProps = {
            disabled: this.props.disabled,
            handleActive: this.handleActive,
            handleFocus: this.handleFocus,
            handleHover: this.handleHover,
            interactiveStyles: this.props.interactiveStyle,
            pointerClick: this.handleClick
        };
        return (React.createElement(InteractiveDom_1.InteractiveDomWrapper, tslib_1.__assign({}, interactiveDomProps),
            React.createElement("div", tslib_1.__assign({}, (_a = {}, _a[this.props.role === 'radio' ? 'aria-checked' : 'aria-pressed'] = this.props.selected, _a), { "aria-disabled": this.props.disabled, "data-tb-test-id": this.props.testId, onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, role: this.props.role, style: this.props.style, tabIndex: this.props.disabled ? undefined : (this.props.disableTabAccessibility ? -1 : 0), title: this.props.title }), this.props.children)));
    };
    ButtonBase.defaultProps = {
        role: 'button'
    };
    return ButtonBase;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.ButtonBase = ButtonBase;
//# sourceMappingURL=ButtonBase.js.map